import React from 'react';

function PrintEtiqueta({ factura, onClose }) {
  const handlePrint = () => window.print();

  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          #etiqueta-area, #etiqueta-area * { visibility: visible; }
          #etiqueta-area {
            position: fixed;
            left: 0; top: 0;
            width: 4in;
            height: 6in;
            margin: 0;
            padding: 0;
          }
          .no-print { display: none !important; }
          @page {
            size: 4in 6in;
            margin: 0;
          }
        }
        @media screen {
          #etiqueta-area {
            width: 4in;
            min-height: 6in;
            margin: 20px auto;
            background: white;
            box-shadow: 0 4px 20px rgba(0,0,0,0.15);
            border-radius: 8px;
            overflow: hidden;
          }
        }
      `}</style>

      {/* Botones */}
      <div className="no-print" style={{ textAlign: 'center', marginBottom: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
        <button onClick={handlePrint} style={{ padding: '10px 24px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>🖨️ Imprimir Etiqueta</button>
        <button onClick={onClose} style={{ padding: '10px 24px', background: '#64748b', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>✕ Cerrar</button>
      </div>

      {/* Etiqueta */}
      <div id="etiqueta-area" style={{ fontFamily: 'Arial, sans-serif', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', height: '6in' }}>

        {/* Header empresa */}
        <div style={{ background: '#0d2461', color: 'white', padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 900, letterSpacing: 0.5 }}>EMBARQUE ORIENTAL, LLC.</div>
            <div style={{ fontSize: 8, opacity: 0.7, marginTop: 1 }}>Florida → República Dominicana</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 8, opacity: 0.7 }}>FURGÓN</div>
            <div style={{ fontSize: 20, fontWeight: 900, lineHeight: 1 }}>#{factura.furgonNumero}</div>
          </div>
        </div>

        {/* Factura + Fecha */}
        <div style={{ background: '#f8fafc', borderBottom: '2px dashed #e2e8f0', padding: '6px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 8, color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>N° Factura</div>
            <div style={{ fontSize: 16, fontWeight: 900, color: '#0d2461', fontFamily: 'monospace', letterSpacing: 1 }}>{factura.numero}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 8, color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>Fecha</div>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#334155' }}>{new Date(factura.fecha).toLocaleDateString('es-DO')}</div>
          </div>
        </div>

        {/* DESTINATARIO — Lo más importante */}
        <div style={{ padding: '12px 14px', borderBottom: '3px solid #0d2461' }}>
          <div style={{ fontSize: 8, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>📥 DESTINATARIO</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: '#0d2461', lineHeight: 1.2, marginBottom: 6 }}>{factura.desNombre}</div>
          <div style={{ fontSize: 11, color: '#334155', fontWeight: 600, marginBottom: 2 }}>{factura.desDireccion}</div>
          <div style={{ fontSize: 13, color: '#0d2461', fontWeight: 700, marginBottom: 2 }}>{factura.desCiudad}</div>
          <div style={{ fontSize: 12, color: '#475569' }}>📞 {factura.desTelefono}</div>
        </div>

        {/* REMITENTE */}
        <div style={{ padding: '8px 14px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
          <div style={{ fontSize: 8, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 3 }}>📤 REMITENTE</div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#334155' }}>{factura.remNombre}</div>
          <div style={{ fontSize: 10, color: '#64748b' }}>{factura.remCiudad} · {factura.remTelefono}</div>
        </div>

        {/* CONTENIDO */}
        <div style={{ padding: '8px 14px', borderBottom: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 8, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>📦 CONTENIDO</div>
          {factura.detalles?.map((d, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#1e293b' }}>
                {d.descripcion}{d.otro ? ` / ${d.otro}` : ''}
              </div>
              <div style={{ display: 'flex', gap: 3, flexShrink: 0, marginLeft: 8 }}>
                {d.cajas > 0 && <span style={{ background: '#dbeafe', color: '#1d4ed8', padding: '2px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>{d.cajas} cj</span>}
                {d.fornitura > 0 && <span style={{ background: '#ede9fe', color: '#7c3aed', padding: '2px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>{d.fornitura} fn</span>}
                {d.tanques > 0 && <span style={{ background: '#dcfce7', color: '#16a34a', padding: '2px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>{d.tanques} tq</span>}
                {d.vehiculo > 0 && <span style={{ background: '#fef3c7', color: '#d97706', padding: '2px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>{d.vehiculo} vh</span>}
                {d.cantidad > 0 && <span style={{ background: '#f1f5f9', color: '#475569', padding: '2px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>x{d.cantidad}</span>}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ padding: '8px 14px', background: '#0d2461', marginTop: 'auto', textAlign: 'center' }}>
          <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)' }}>FL: (386) 281-3237 · (386) 320-2613 · RD: (829) 639-4341</div>
        </div>

      </div>
    </div>
  );
}

export default PrintEtiqueta;